import { Vue } from 'vue'
import { API } from './core'

export class Account {
  create () {
    return API.instance().put('/account/', this).then((resp) => {
      const item = Account.createFromJson(resp.data.data.data)
      Account.Cached[item.key] = item
      return item
    })
  }
  static newEmpty () {
    let account = new Account()
    account.name = ''
    account.opening_balance = 0
    account.currency = null
    return account
  }
  updateFromServer (state) {
    return API.instance().get(`/account/${this.key}`).then((resp) => {
      const updatedAccount = resp.data.data.data

      Object.entries(updatedAccount).forEach(obj => Vue.set(this, obj[0], obj[1]))
      if (state) {
        state.changeToLoaded()
      }
      Account.Cached[updatedAccount.key] = this
    })
  }

  static sortedItems (items) {
    return items.sort((x, y) => {
      if (x.name > y.name) {
        return 1
      }
      return -1
    })
  }

  static createFromJson (raw) {
    let account = Account.newEmpty()
    account = Object.assign(account, raw)
    return account
  }

  static list (useFresh) {
    if (!useFresh) {
      const values = Account.sortedItems(Object.values(Account.Cached))
      if (values.length > 1) {
        return Promise.resolve(values)
      }
    }

    return API.instance().get('/account/').then((resp) => {
      let data = resp.data.data.data.map((raw) => Account.createFromJson(raw))
      data = Account.sortedItems(data)
      data.forEach((account) => {
        Account.Cached[account.key] = account
      })
      return data
    })
  }

  static fetch (accountKey) {
    return this.fromKey(accountKey).updateFromServer()
  }

  static fromKey (accountKey) {
    const account = Account.newEmpty()
    account.key = accountKey
    account.name = '-'
    return account
  }

  static useCachedOrFetch (accountKey) {
    if (Account.Cached[accountKey]) {
      return Account.Cached[accountKey]
    }
    const account = this.fromKey(accountKey)
    Account.Cached[accountKey] = account
    if (accountKey && accountKey !== '0') {
      account.updateFromServer()
    }
    return account
  }
}

Account.Cached = {}

export class AccountKey {
  constructor (key) {
    this.key = key
    if (key && key.key) {
      this.key = key.key
    }
    this.loadedAccount = null
  }
  get account () {
    if (this.loadedAccount === null) {
      this.loadedAccount = Account.useCachedOrFetch(this.key)
    }
    return this.loadedAccount
  }

  getAccount () {
    return this.account
  }

  toString () {
    return this.key
  }
}
